
let currentUser = localStorage.getItem('currentUser');
let currentUserObject = currentUser ? JSON.parse(currentUser) : null;
let productInfoKey = currentUserObject ? `${currentUserObject.username}_productInfo` : null;

debugger
let initialState = productInfoKey && localStorage.getItem(productInfoKey) ?
    JSON.parse(localStorage.getItem(productInfoKey)!) : {
        'group': null,
        'productId': null,
        'productGroupPath': '',
        'productPath': '',
        'productPrefersLitres': ''
    };

export const productReducer = (state: any = initialState, action: any) => {

    switch (action.type) {
        case 'GROUP_SELECTION':
        case 'PRODUCT_SELECTION':
            var newState = { ...state };

            var payload = JSON.parse(action.payload);

            newState.group = payload.group;
            newState.productId = payload.productId;
            newState.productGroupPath = payload.productGroupPath;
            newState.productPath = payload.productPath;
            newState.productName = payload.productName;
            newState.productPrefersLitres = payload.productPrefersLitres;

            return newState;
    }

    return state;
}
